import { Button } from "@/src/components/buttons";
import { Card } from "@/src/components/cards";
import {
  closeDrawer,
  openConfirmDialog,
  openDrawer,
} from "@/src/components/dialogs";
import { TemporaryLeave, Hospitalisation, Patient } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import {
  formatDate,
  getDayCount,
  getItemId,
  getUserId,
  getUserShortName,
  isToday,
} from "@/src/utils/utils";
import { TemporaryLeaveForm } from "../temporaryLeaveForm";

export default function TemporaryLeaveCard({
  item,
  patient,
  parent,
  onClick,
  onChange,
}: {
  item: TemporaryLeave;
  patient: Patient;
  parent: Hospitalisation;
  onClick: () => void;
  onChange: (item: TemporaryLeave) => void;
}) {
  function getStatusName(item: TemporaryLeave) {
    if (item.status == "pending") return "En attente";
    if (item.status == "waitingForValidation") return "En attente";
    if (item.status == "validated") return "Validée";
    if (item.status == "finished") return "Terminée";
    if (item.status == "canceled") return "Rejetée";
    return "";
  }

  if (!item) return null;

  async function openTemporaryLeaveForm(temporaryLeave: TemporaryLeave) {
    await openDrawer({
      id: "temporaryLeaveDrawer",
      title: "Autorisation de sortie",
      content: (
        <TemporaryLeaveForm
          temporaryLeave={temporaryLeave}
          onChange={(newValue) => {
            temporaryLeave = newValue;
          }}
        />
      ),
      onConfirm: async () => {
        let result = await apiFetch("temporaryLeaves", "addOne", {
          temporaryLeave,
        });
        if (!result) return;
        parent.temporaryLeave = result;
        await apiFetch(
          "hospitalisations",
          "addOne",
          {
            hospitalisation: {
              id: getItemId(parent),
              type: "hospitalisation",
              temporaryLeave: result,
            },
          },
          "Erreur lors de l'enregistrement de l'hospitalisation"
        );
        closeDrawer("temporaryLeaveDrawer");
        onChange(result);
      },
    });
  }

  return (
    <Card
      color={"blue"}
      leading={
        <div className=" mtop5 left br mright5">
          <div className="bold">{getDayCount(parent?._date, item._date)}</div>
          <div className="gray">{formatDate(item._date, "HH:mm")}</div>
        </div>
      }
      title={`Permission de sortie (${getStatusName(item)})`}
      subTitle={
        <div>
          <div>Faite par {getUserShortName(item.creator)}</div>
        </div>
      }
      onEdit={() => {
        openTemporaryLeaveForm(item);
      }}
      onClick={async () => {
        await onClick();
      }}
      onDelete={
        getUserId() == getItemId(item.creator) && isToday(item._date)
          ? async () => {
              await openConfirmDialog({
                content: "Voulez-vous vraiment supprimer cet élément ?",
                onConfirm: async () => {
                  await apiFetch("temporaryLeaves", "deleteOne", {
                    id: item.id,
                  });
                  onChange?.(item);
                },
              });
            }
          : undefined
      }
    >
      <div className="c1 gap10">
        <div>
          Du <strong>{formatDate(item.exitDate, "LL")}</strong> au{" "}
          <strong>{formatDate(item.returnDate, "LL")}</strong>
        </div>
      </div>
    </Card>
  );
}
